export var ListType;
(function (ListType) {
  ListType["ORDERED"] = "ol";
  ListType["UNORDERED"] = "ul";
})(ListType || (ListType = {}));